import React from 'react'
const {useRef} = React
import useLayoutEffect from '@react-hook/passive-layout-effect'
export const useKeycode = (which, callback) =>
  useKeycodes(
    {
      [which]: callback,
    },
    [which, callback]
  )
export const useKeycodes = (handlers, dependencies) => {
  const ref = useRef(null)

  function _ref(event) {
    var _handlers$event$which

    ;(_handlers$event$which = handlers[event.which]) === null ||
    _handlers$event$which === void 0
      ? void 0
      : _handlers$event$which.call(handlers, event)
  }

  useLayoutEffect(
    () => {
      const current = ref.current

      if (current) {
        const maybeCallback = _ref
        current.addEventListener('keydown', maybeCallback)
        return () => {
          current.removeEventListener('keydown', maybeCallback)
        }
      }
    },
    dependencies ? [ref.current].concat(dependencies) : void 0
  )
  return ref
}
export default useKeycode
